// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FormLogo_wrapper__HsLQk"};